import {
  filter,
  isArrayLike,
  isDate,
  isEmpty,
  isObjectLike,
  isSet,
  omitBy,
} from 'lodash'

export function isTrulyEmpty(value: any): value is undefined | null {
  if (typeof value === 'boolean') {
    return false
  }

  if (isDate(value)) {
    return false
  }

  if (value == null || value === '') {
    return true
  }

  if (typeof value === 'string' && value.trim().length === 0) {
    return true
  }

  if (typeof value === 'number') {
    return false
  }

  if (isSet(value)) {
    return isEmpty(filter(Array.from(value), (v) => v != null))
  }

  if (isArrayLike(value)) {
    return isEmpty(filter(value, (v) => v != null))
  }

  if (isObjectLike(value)) {
    value = omitBy(value, isTrulyEmpty)
    return isEmpty(value)
  }

  return false
}

export function removeEmptyPropertiesFromObject(obj: any) {
  return omitBy(obj, isTrulyEmpty)
}
